module.exports = __webpack_public_path__ + "img/img000.b0005280.png";